import { AfterViewChecked, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ViewChild } from '@angular/core';
import { trigger, transition, animate, style } from '@angular/animations';
import { ActivatedRoute, Router, Event, NavigationStart, NavigationEnd, NavigationError } from '@angular/router';
import { ProductSelectService } from 'app/ts/services/product-select.service';
import { IdentificationTypeService } from 'app/ts/services/identification-type.service';
import { PersonalDetailsComponent } from 'app/forms/broker-portal/personal-details/personal-details.component';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { DataSharingService } from 'app/data-sharing-service';
import { ApiService } from 'app/ts/ApiService';


@Component({
  selector: 'app-client-capture',
  templateUrl: './client-capture.component.html',
  styleUrls: ['./client-capture.component.scss'],
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({ transform: 'translateX(-50%)' }),
        animate('100ms ease-in', style({ transform: 'translateX(0%)' }))
      ]),
      transition(':leave', [
        animate('100ms ease-in', style({ transform: 'translateX(-50%)' }))
      ])
    ])
  ]
})

@ViewChild('picker', { read: undefined, static: false })
export class ClientCaptureComponent implements OnInit, AfterViewChecked {

  onClientAddressTabActivated() {
    console.log("get address")
  }

  clientDetailsForm: FormGroup;
  bankDetails: FormGroup;
  employmentDetails: FormGroup;
  uploadDocumentsForm: FormGroup;
  selectedIndex: number;
  formStep: number;
  currentRoute: string;
  showProductSelection: boolean = true;
  clientId: number;
  isPassport$ = this._identityType.isPassport;
  productList$ = this._productSelect.productList;
  @ViewChild('clientDetails') clientDetails: PersonalDetailsComponent;
  formDataEvent: EventEmitter<any> = new EventEmitter<any>();

  onFormSubmitted(formData: FormGroup) {
    // Pass the form data to PersonalDetailsComponent
    //this.clientDetails.receiveFormData(formData);
    this.formDataEvent.emit(formData);
  }
  
  constructor(private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private _productSelect: ProductSelectService,
    public _identityType: IdentificationTypeService,
    private api: ApiService,
    private dataSharingService: DataSharingService
  ) {}

  ngOnInit(): void {
    this._productSelect.updateLoanAmount(0);
    this._productSelect.updateLoanTerm(0);
    this._productSelect.updateLoanType("Short Term Loan");

    this.clientDetailsForm = this.formBuilder.group({
      name: ['', Validators.required],
      surname: ['', Validators.required],
      title: ['', Validators.required],
      mobileNumber: ['1', Validators.required],
      email: ['', Validators.required],
      workNumber: [''],
      idNumber: ['', Validators.required],
      dateOfBirth: ['', Validators.required]
    });

    this.selectedIndex = 0;
  }

  onTabChange(event: MatTabChangeEvent) {
    // Code to run when the tab changes
    if (event.index === 1) { // Check if Tab 2 is selecte
    }
  }


  ngAfterViewChecked(): void {
    var staffId = sessionStorage.getItem('staffId');
    //capture logic
    if(Number(sessionStorage.getItem("clientId")) == 0){

      //search logic
      this.route.params.subscribe(params => {
      if (this.clientId != params['clientId']) {
        this.clientId = +params['clientId'];
        sessionStorage.setItem('staffId', this.clientId.toString());
     

        //if (this.clientId != 0) {
          this.showProductSelection = true;
        //} 
        //else {
        //  if(staffId == '630' || staffId == '607' || staffId == '650')
        //  {
        //    this.showProductSelection = true;
        //  }
        //}


      }
    });
    }
   
    //if(staffId == '630' || staffId == '607' || staffId == '650')
    //{
    //  this.showProductSelection = true;
    //}else{
      this.showProductSelection = true;
    //}
  }

  findClientTriggered() {
    var idNumber = sessionStorage.getItem('searchClientID');

    if (idNumber != '' && idNumber != null) {
      this.showProductSelection = false;
    }
    else {
      this.showProductSelection = true;
    }
  }

  public previousStep() {
    this.selectedIndex -= 1;
  }

  updateStep() {
    
    if (this.selectedIndex == 5) {
      this.reload();
    }
    else {
      this.selectedIndex += 1;
    }
  }

  onChange() {
    this.clientId = Number(sessionStorage.getItem("clientId"));

    sessionStorage.setItem("ClientTokenDetails", JSON.stringify(this.clientDetails));
    


  
  }

  reload() {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate(['./'], { relativeTo: this.route });
  }
}
